<ng-template #content_product_child_measurement let-offcanvas>
    <div class="{{localService.selectedLanguageCode}}"
        *ngIf="localService.languageContent && localService.languageContent.product_config">
        <div class="side_popup_header">
            <span>{{productCode}}&nbsp;-&nbsp;{{productName}}</span>
            <button class="button_icon" (click)="onCloseTrigger()">close</button>
        </div>
    </div>
    <div class="side_popup_body" style="height: 100%;"
        [ngStyle]="{'max-height' : (localService.sideBarBodyHeight) + 'px'}">
        <div *ngIf="item">
            <div class="row" *ngIf="items.length > 0">
                <div class="col-12">
                    <app-tab [tabs]="tabs" [(selectedKey)]="selectedTab" [isShowRefresh]="selectedTab == '1'"
                        (onTabSelected)="onLoad(true)" (onRefresh)="onLoad(true)" />
                </div>
            </div>
            <div *ngIf="selectedTab == '1'">
                <div class="banner center" style="width:calc(100% - 30px);margin-top: 15px;">
                    <div class="row freeze_height row_header">
                        <div class="col-3">
                            <span class="en">1&nbsp;</span>
                            <span>{{parentMeasurmentTypeText}}</span>
                            <span class="en">&nbsp;=</span>
                        </div>
                        <div class="col-5">
                            {{localService.languageContent.product_config.child_measurement_type}}
                        </div>
                        <div class="col-4">
                            {{localService.languageContent.product_config.inventory_val}}
                        </div>
                    </div>
                    <div class="custom_rows_body">
                        <div class="row styled_row" *ngFor="let item of items">
                            <div class="col-3">
                                {{item.v5}}
                            </div>
                            <div class="col-5">
                                {{item.v4}}
                            </div>
                            <div class="col-4">
                                {{item.v3}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="selectedTab == '2' || items.length == 0">
                <div class="row">
                    <div class="col-md-6">
                        <div [id]="elementIds.lbl_measure_type">
                            <app-label [Text]="localService.languageContent.product_config.child_measurement_type"
                                [IsMandatory]="true" />
                        </div>
                        <div>
                            <ngx-select [placeholder]="localService.languageContent.product_config.sel_measurement_type"
                                [(ngModel)]="item.v2" [noAutoComplete]="false" [items]="measurmentTypes"
                                [optionValueField]="'key'" [optionTextField]="'value'" (select)="onAction(1)">
                                <ng-template ngx-select-option-selected ngx-select-option let-option let-text="text">
                                    <span
                                        [ngStyle]="{'font-weight': option.data.isSelected ? 'bold' : 'normal'}">{{option.data.value}}</span>
                                </ng-template>
                            </ngx-select>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div *ngIf="item.v1">
                            <div>
                                <app-label
                                    [Text]="localService.languageContent.product_config.equivalent_val + ' - ' + parentMeasurmentTypeText"
                                    [IsMandatory]="false" />
                            </div>
                            <div>
                                <button class="button_icon icon_adjust"
                                    title="{{item.isSelected ? localService.languageContent.table.make_inactive : localService.languageContent.table.make_active}}"
                                    [ngStyle]="{'color': item.isSelected ? 'yellowgreen' : 'orangered' }">
                                    {{item.isSelected ? "toggle_on" : "toggle_off"}}
                                </button>
                                <input autocomplete="off" type="number" class="number" [(ngModel)]="item.v3"
                                    style="width:calc(100% - 100px);margin-left: 10px;margin-right: 20px;"
                                    placeholder="*{{localService.languageContent.product_config.equivalent_to}}"
                                    title="{{localService.languageContent.product_config.equivalent_to}}"
                                    [ngClass]="item.v3 ? 'en' : ''" />
                                <button class="button_icon icon_adjust button_icon_color"
                                    (click)="onAction(2)">{{item.key ?
                                    'save' : 'add'}}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="!pricing" style="height: calc(100vh - 200px);">
                    &nbsp;
                </div>
                <div *ngIf="pricing">
                    <div>
                        <app-pricing-container [(items)]="pricing.pricings" [isNotConsiderTax]="isNotConsiderTax"
                            [businessTaxes]="pricing.businessTaxesFull" [businessTaxCategories]="businessTaxCategories"
                            [(selectedBusinessTaxCategoryId)]="selectedBusinessTaxCategoryId"
                            [isEnableTaxCategory]="false">
                        </app-pricing-container>
                    </div>
                    <div *ngIf="isExcludePrice">
                        <app-label [Text]="localService.languageContent.product_config.excluded"
                            [IsNeedNewLine]="true" />
                        <app-pricing-container [(items)]="pricing.pricingsExcluded" [isNotConsiderTax]="true"
                            [businessTaxCategories]="businessTaxCategories" [businessTaxes]="pricing.businessTaxesFull"
                            [isExcluded]="true" [isShowLabel]="false"
                            [(selectedBusinessTaxCategoryId)]="selectedBusinessTaxCategoryId"
                            [isEnableTaxCategory]="false">
                        </app-pricing-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="side_popup_footer" *ngIf="pricing && (selectedTab == '2' || items.length == 0)">
        <div class="row">
            <div class="col-8" style="text-align: left;">
                <span *ngIf="message != ''"
                    [ngStyle]="{'color': isRedAlert ? 'orangered' : 'darkgreen' }">{{message}}</span>
            </div>
            <div class="col-4" style="text-align: right;">
                <button type="button" class="btn btn-primary" (click)="onAction(3)">
                    {{pricing.detail.isExistingDataAvailable ? localService.languageContent.common.save :
                    localService.languageContent.common.create}}
                    {{localService.languageContent.product_config.pricing_details}}
                </button>
            </div>
        </div>
    </div>
</ng-template>